import React from 'react';
import BaseInput from './BaseInput';

export default props => {
  return <BaseInput {...props} />;
};
